import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { colors } from "../../utils/colors";

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search license plates...",
}) => {
  return (
    <TextField
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      sx={{
        minWidth: 250,
        "& .MuiOutlinedInput-root": {
          fontFamily: "SigmaSans",
        },
        "& .MuiInputBase-input": {
          fontFamily: "SigmaSans",
        },
        "& .MuiInputLabel-root": {
          fontFamily: "SigmaSans",
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon sx={{ color: colors.secondaryText, fontSize: 20 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default SearchBar;
